<div
  class="border-weak bg-surface flex shrink-0 items-center gap-2 border-b py-1.5 pr-2 pl-3">
  <span
    class="text-text-tertiary shrink-0 font-mono text-[10.5px] font-semibold tracking-wider uppercase">
    {{ 'features.entity_details.title' | translate }}
  </span>
  <div
    role="tablist"
    cdkDropList
    cdkDropListOrientation="horizontal"
    [id]="listId()"
    [cdkDropListConnectedTo]="connectedTo()"
    class="scrollbar-hide flex min-w-0 flex-1 items-center gap-0.5 overflow-x-auto"
    (cdkDropListDropped)="dropped.emit($event)">
    @for (uid of uids(); track uid) {
      <div
        cdkDrag
        [cdkDragData]="uid"
        class="flex shrink-0 cursor-grab items-center gap-1.5 rounded-sm border py-1 pr-1.5 pl-2 font-mono text-[11px] whitespace-nowrap transition-colors"
        [class]="
          uid === activeUid()
            ? 'bg-elevated border-default text-accent-main font-semibold shadow-xs'
            : 'text-text-secondary hover:bg-interactive border-transparent'
        ">
        <button
          type="button"
          role="tab"
          class="cursor-pointer"
          [attr.aria-selected]="uid === activeUid()"
          (click)="activate.emit(uid)">
          {{ uid }}
        </button>
        @if (splitTarget(); as target) {
          @let splitLabel =
            (target === 'left'
              ? 'features.entity_details.move_to_left'
              : 'features.entity_details.move_to_right'
            ) | translate;
          <button
            type="button"
            data-testid="detail-tab-split"
            class="text-text-tertiary hover:text-accent-main hover:bg-interactive flex cursor-pointer rounded-xs p-px transition-colors"
            [attr.aria-label]="splitLabel"
            [title]="splitLabel"
            (click)="split.emit(uid)">
            <i [class]="SPLIT_ICONS[target]" class="pointer-events-none text-[10px]"></i>
          </button>
        }
        <button
          type="button"
          class="text-text-tertiary hover:text-danger hover:bg-danger-soft flex cursor-pointer rounded-xs p-px transition-colors"
          [attr.aria-label]="'features.entity_details.remove' | translate"
          (click)="closeOne.emit(uid)">
          <i [class]="ICONS.x" class="pointer-events-none text-[10px]"></i>
        </button>
      </div>
    }
  </div>
  <button
    type="button"
    class="text-text-tertiary hover:text-text-primary hover:bg-interactive flex shrink-0 cursor-pointer rounded-sm p-1 transition-colors"
    [attr.aria-label]="'features.entity_details.close_all' | translate"
    [title]="'features.entity_details.close_all' | translate"
    (click)="closeAll.emit()">
    <i [class]="ICONS.x" class="pointer-events-none"></i>
  </button>
</div>
